// SalesTrends.js
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import MuiDenseTable from "../../../common-utilities/core/mui-dense-table";
import { HOSTNAME, REPORT_HOSTNAME } from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/pl-report";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { toast } from "react-toastify";
import { getTrendsHeader } from "./helper";
import { downloadFileFromUrl } from "../../../pl-report/utils/common-utils";

const SalesTrends = ({
  tabIndex,
  filters,
  dateRanges,
  slug,
  token,
  searchTrigger,
  setSearchTrigger,
  agg,
  isDownload = false,
  setIsDownload,
}) => {
  const [data, setData] = useState({});
  const payloadHandler = () => {
    const payload = {};

    (filters.selectedFilters || []).forEach((filter) => {
       if (filter.id === "storeOpeningDate") {
          
    
          if (typeof filter.value === "object" && filter.value !== null) {
            if (filter.value.startDate && filter.value.endDate) {
              payload[filter.id] = filter.value;
            }
          }
        } else if (Array.isArray(filter.value) && filter.value.length > 0) {
          payload[filter.id] = filter.value.map((v) => v.value ?? v);
        }
   
    });
    if (filters?.viewSelectedFilters?.length) {
      const viewFil = {};
      (filters.viewSelectedFilters || []).forEach((filter) => {
        if (Array.isArray(filter.value) && filter.value.length > 0) {
          viewFil[filter.id] = filter.value.map((v) => v.value ?? v);
        }
      });
      payload["viewFilters"] = viewFil;
    }
    return payload;
  };
  const flattenRow = (row) => {
    const flatRow = { ...row, showNow: true };
    // Handle flat `data: []`
    if (row.data && Array.isArray(row.data)) {
      row.data.forEach((item) => {
        flatRow[item.key] = item.value;
      });
    }
    return flatRow;
  };

  const loadData = () => {
    let params = {
      agg,
    };
    let payload = payloadHandler();

    if (dateRanges?.startMonth && dateRanges?.startYear) {
      params.date = `${dateRanges?.startMonth}/01/${dateRanges?.startYear}`;
    }

    if (filters?.metric?.length > 0) {
      payload["metric"] = filters?.metric;
    }

    invokeApi(
      HTTP_METHODS.POST,
      `${REPORT_HOSTNAME}${REST_URLS.OPS_TRENDS}`,
      payload,
      params,
      null,
      slug,
      token
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          setData(response);
        }
      })
      .catch(() => {});

    if (searchTrigger) {
      setSearchTrigger(false);
    }
  };
  const downloadData = () => {
    let params = {
      agg,
    };
    let payload = payloadHandler();

    if (dateRanges?.startMonth && dateRanges?.startYear) {
      params.date = `${dateRanges?.startMonth}/01/${dateRanges?.startYear}`;
    }

    if (filters?.metric?.length > 0) {
      payload["metric"] = filters?.metric;
    }

    invokeApi(
      HTTP_METHODS.POST,
      `${REPORT_HOSTNAME}${REST_URLS.OPS_TRENDS_DOWNLOAD}`,
      payload,
      params,
      null,
      slug,
      token
    )
      .then((res) => {
        if (res.message || !res.url) {
          toast.error(`${res.message}, Failed to download file`);
        } else {
          downloadFileFromUrl(res.url);
        }
        setIsDownload(false);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    if (tabIndex === 1) {
      loadData();
    }
  }, [searchTrigger, agg]);
  useEffect(() => {
    if (isDownload && tabIndex === 1) {
      downloadData();
    }
  }, [isDownload]);
  return (
    <Box sx={{ p: 2 }}>
      {Object.keys(data).length > 0 ? (
        Object.keys(data)?.map((region, index) => {
          const dataList = data[region]?.map(flattenRow);
          const columnsList = getTrendsHeader(data[region], region);
          return (
            <Box key={index} sx={{ mb: 5 }}>
              <MuiDenseTable dataList={dataList} columnsList={columnsList} />
            </Box>
          );
        })
      ) : (
        <Typography variant="h4" textAlign="center" mt={5}>
          No data found
        </Typography>
      )}
    </Box>
  );
};

export default SalesTrends;
